import { toast } from 'react-toastify';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  AddRelationFailure,
  AddRelationSuccess,
  EditRelationFailure,
  EditRelationSuccess,
} from '../../Redux/Actions/RelationAction';
import { ADD_RELATION, EDIT_RELATION } from '../../Redux/Actiontype';
import routeRules from '../../Routes/routeRules';
import history from '../../Store/history';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const AddRelationshipEpic = action$ =>
  action$.pipe(
    ofType(ADD_RELATION),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/addRelationship`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.relationshipmanagement, toast.success(response.response.message));
              return of(AddRelationSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              console.log(response.response);
              return of(AddRelationFailure(response.response));
            }
          }),
        ),
    ),
  );

export const EditRelationshipEpic = action$ =>
  action$.pipe(
    ofType(EDIT_RELATION),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editRelationship`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditRelationSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditRelationFailure(response.response));
            }
          }),
        ),
    ),
  );
